import React from 'react';
import PropTypes from 'prop-types';
import { StatisticBase, Content } from './Statistic.styles';
import { NoDataTextSmall } from '../NoData/NoData';
import { TextMedium, TextMediumRapid } from '../../common/text';
import { valueToMagnitude } from 'common/numbers';
import { DeltaCell } from '../KPICellStatistic/KPICellStatistic.styles';
import KPITooltip from '../KPICellStatistic/KPITooltip';

export const EbitStatistic = ({ heading, value }) => {
    const [ebitRounded, ebitMagnitude] = valueToMagnitude(value, '£', 1);
    return (
        <StatisticBase className="base">
            <div>
                <TextMediumRapid noWrap className="heading" bold>
                    {heading}
                </TextMediumRapid>
                <Content alignItems="center">
                    {ebitRounded != null && (
                        <KPITooltip text="EBIT is calculated based on the selected actual value and the target value">
                            <DeltaCell delta={ebitRounded}>
                                <TextMedium bold>{ebitRounded ? `£ ${ebitRounded} ${ebitMagnitude}` : '-'}</TextMedium>
                            </DeltaCell>
                        </KPITooltip>
                    )}
                    {ebitRounded == null && <NoDataTextSmall />}
                </Content>
            </div>
        </StatisticBase>
    );
};

EbitStatistic.displayName = 'EbitStatistic';

EbitStatistic.propTypes = {
    heading: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
